<template>
  <div v-if="isStages">
    <h3 class="text-center">All Stages</h3>
    <table class="table table-striped">
      <thead>
        <th>Name</th>
        <th>Next Stage</th>
        <th>Message</th>
        <th>Edit</th>
        <th>Delete</th>
      </thead>
      <tbody>
        <tr v-for="(eachStage, key) in stages" :key="key">
          <td>{{key}}</td>
          <td>{{eachStage.next}}</td>
          <td>{{eachStage.text}}</td>
          <td><i class="fa fa-pencil" v-on:click="editStage(key)" aria-hidden="true"></i></td>
          <td><i class="fa fa-times-circle" v-on:click="removeStage(key)" aria-hidden="true"></i></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import { logout, createUser } from '../../../utils/auth'
// import { showMessage } from '../../../utils'
export default {
  name: 'app-all-stages',
  props: ['stages'],
  methods: {
    /**
     * @function removeStage
     * @description delete a stage from the app flow
     * @param {string} stageName - name of the stage
     */
    removeStage (stageName) {
      this.$emit('remove', stageName)
    },

    /**
     * @function editStage
     * @description edit a stage on the app flow
     * @param {string} stageName - name of the stage
     */
    editStage (stageName) {
      this.$emit('edit', stageName)
    }
  },
  computed: {
    isStages () {
      return Object.keys(this.stages).length
    }
  }
}
</script>



// WEBPACK FOOTER //
// allstages.vue?6f426e13